import { ScaleLinear, ScaleTime } from 'd3-scale';

import { TimeBottomAxis } from '../../../core/components/axes/components/TimeBottomAxis.js';
import { ValueBottomAxis } from '../../../core/components/axes/components/ValueBottomAxis.js';
import { getFormattedTicks } from '../../../core/utils/formatter-by-ticks.js';
import { getFormatter } from '../../../core/utils/get-formatter.js';
import { getHorizontalNumTicks } from '../../../core/utils/ticks.js';
import { DEFAULT_AXIS_HIDDEN } from '../../constants.js';
import { useAnnotationsAxisConfig } from './hooks/useAnnotationsAxisConfig.js';
import {
  isNumericalAxis,
  isNumericalScale,
} from './types/annotations-x-axis-props.js';

interface AnnotationsAxisProps {
  scale: ScaleTime<number, number> | ScaleLinear<number, number>;
  width: number;
  height: number;
  labelsOffset: number;
}

export const AnnotationsAxis = ({
  scale,
  width,
  height,
  labelsOffset,
}: AnnotationsAxisProps) => {
  const config = useAnnotationsAxisConfig();
  const horizontalNumTicks = getHorizontalNumTicks(width);

  const hidden = config?.hidden ?? DEFAULT_AXIS_HIDDEN;

  let formatterResult;

  if (config && isNumericalAxis(config)) {
    const formatter = getFormatter(config.formatter);

    formatterResult = getFormattedTicks(
      horizontalNumTicks,
      scale,
      config.unit,
      formatter,
    );
  } else {
    formatterResult = getFormattedTicks(
      horizontalNumTicks,
      scale,
      undefined,
      undefined,
    );
  }

  const commonProps = {
    containerWidth: width - labelsOffset,
    containerHeight: height,
    ticks: formatterResult.ticks,
    formattedTicks: formatterResult.formattedTicks,
    label: config?.label,
  };

  return !hidden ? (
    <div
      style={{
        marginLeft: `${labelsOffset}px`,
      }}
    >
      {isNumericalScale(scale) ? (
        <ValueBottomAxis scale={scale} {...commonProps} />
      ) : (
        <TimeBottomAxis scale={scale} {...commonProps} />
      )}
    </div>
  ) : null;
};
